import React, {useContext, useEffect, useState} from "react";
import {Layout, Modal, Row} from "antd";
import style from "./Lives.module.scss";
import {useTranslation} from "react-i18next";
import useFetch, {CachePolicies} from "use-http";
import {JanusAPIEndpoint} from "../../../service/janus.service";
import {getToken} from "../../../service/auth.service";
import {useNavigate} from "react-router-dom";
import SkeletonCard from "../Groups/SkeletonCard";
import CardContainer from "../../Group/CardGroup/CardContainer";
import LiveCard from "../../Group/CardGroup/LiveCard";
import {HomeContext} from "../../Home/Home.context";
import {pathRoutes} from "../../../props/util.props";
import {checkEmpty, getAuthorization,} from "../../../service/util.service";
import {UserAPIEndpoint} from "../../../service/user.service";
import {requestIcon} from "../Request/request.utils.props";
import NoData from "src/components/shared/NoDataDisplay/NoData";
import {attachVideoRoom} from "../../videoCall/VideoConference/utils/VideoRoom/publisher";
import axios from "axios";
import {getJanusServerURL} from "../../../service/config.service";
import CenterConfirmModal from "../../../components/shared/Modal/CenterConfirmModal";
import CenterButton from "../../../components/shared/button/CenterButton";

const { Content } = Layout;

let janus: any;

const Lives = (props: any) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const homeContext: any = useContext(HomeContext);
  const [liveRoomList, setLiveRoomList]: any = useState(null);
  const [loaded, setLoaded] = useState(false);
  const [showLiveModal, setShowLiveModal] = useState<boolean>(false);

  const noDataHeaderText = t("No Live available");
  const nodatatext = t("When someone live, they'll appear on this page");

  const { confirm, error } = Modal;

  const livesRoomAPI = useFetch(
    window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + JanusAPIEndpoint.LiveRoom,
    {
      headers: { Authorization: `Bearer ${getToken()}` },
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const janusRoomStatus = async (groupId: string, status: any) => {
    return await axios.post(
      window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + JanusAPIEndpoint.VideoRoom + `/updateStatus`,
      { groupID: groupId, isActive: status },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: getAuthorization(),
        },
      }
    );
  };
  const fetchLiveRoomList = async () => {
    try {
      let res = await livesRoomAPI.get();
      console.log("[GetLiveRoom]", res);
      setLiveRoomList(res);
      if (res?.length > 0) {
        getActiveLives(res);
      }
      setLoaded(true);
    } catch (e) {
      console.error("[GetLiveRoomListError]", e);
      setLoaded(true);
    }
  };


  const api = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL, {
    cachePolicy: CachePolicies.NO_CACHE,
  });

  const onLive = async () => {
    let token = getToken();
    if (!checkEmpty(token)) {
      let userdata = await api.get(UserAPIEndpoint.Me);
      // Auth.getUserData();
      // let userdata = parseJwt(token);
      let id = userdata?.id;
      if (!id) return;
      navigate(
        pathRoutes.PersonalLive + "?id=" + id + "&type=publisher"
      );
    }
    setShowLiveModal(false);
  }

  const handleLive = () => {
    confirm({
      title: t("Do you want to live"),
      // icon: <ExclamationCircleOutlined />,
      // content: 'Some descriptions',
      async onOk() {
        let token = getToken();
        if (!checkEmpty(token)) {
          let userdata = await api.get(UserAPIEndpoint.Me);
          // Auth.getUserData();
          // let userdata = parseJwt(token);
          let id = userdata?.id;
          if (!id) return;
          navigate(
            pathRoutes.PersonalLive + "?id=" + id + "&type=publisher"
          );
        }
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const getActiveLives = async (confRoom: any) => {
    let server: any = null;

    try {
      server = await getJanusServerURL();
    } catch (err) {
      return;
    }
    //@ts-ignore
    const videoOpaqueId = "videoroom-" + window.Janus.randomString(12);

    //@ts-ignore
    window.Janus.init({
      debug: "all", callback: function () {
        //@ts-ignore
        if (!window.Janus.isWebrtcSupported()) {
          console.log("No WebRTC support... ");
          return;
        }

        //@ts-ignore
        janus = new Janus(
          {
            server: server,
            success: function () {

              attachVideoRoom(janus, videoOpaqueId, null, null, null, null, true,
                (mixerPlugin: any, eventType: any, data: any) => {

                  if (eventType === "success") {
                    if (confRoom.length <= 7) {
                      confRoom.forEach((conf: any) => {
                        let updatedAt = new Date(conf?.confRoom?.updatedAt);
                        let now = new Date();
                        // @ts-ignore
                        let diff = now - updatedAt;
                        if (diff <= 10000) return;

                        console.log("Conf", conf?.confRoom?.confRoomID, diff)
                        let listParticipants = {
                          request: "listparticipants",
                          room: conf?.confRoom?.confRoomID,
                        };

                        mixerPlugin.send({
                          message: listParticipants,
                          success: async function (result: any) {
                            console.log("Result", result);
                            if (result?.participants?.length === 0) {
                              await janusRoomStatus(conf?.confRoom?.groupID, false)
                              // @ts-ignore
                              setLiveRoomList((oldGroup: any[]) => oldGroup.filter((item: { confRoom: { groupID: any; }; }) => item?.confRoom?.groupID !== conf?.confRoom?.groupID));
                            } else if (result?.error_code === 426) {
                              await janusRoomStatus(conf?.confRoom?.groupID, false)
                              // @ts-ignore
                              setLiveRoomList((oldGroup: any[]) => oldGroup.filter((item: { confRoom: { groupID: any; }; }) => item?.confRoom?.groupID !== conf?.confRoom?.groupID));
                            } else {
                              // await janusRoomStatus(conf?.confRoom?.groupID, true)
                            }
                          },
                          error: function (error: any) {
                            try {
                              janus.destroy();
                            } catch (e) {

                            }
                          }
                        });
                      });
                      try {
                        janus.destroy();
                      } catch (e) {

                      }
                    } else {
                      let roomList = {
                        request: "list"
                      };

                      mixerPlugin.send({
                        message: roomList,
                        success: function (result: any) {

                          confRoom.forEach((con: {
                            confRoom: {
                              groupID: string;
                              confRoomID: any;
                            };
                          }) => {
                            let conDetails = result?.list?.find((r: any) => r.room === con?.confRoom?.confRoomID);
                            if (conDetails?.num_participants === 0) {
                              console.log("Result", conDetails);
                              janusRoomStatus(con?.confRoom?.groupID, false)
                              // @ts-ignore
                              setLiveRoomList((oldGroup: any[]) => oldGroup.filter((item: { confRoom: { groupID: any; }; }) => item?.confRoom?.groupID !== con?.confRoom?.groupID));
                            } else if (result?.error_code === 426) {
                              janusRoomStatus(con?.confRoom?.groupID, false)
                              // @ts-ignore
                              setLiveRoomList((oldGroup: any[]) => oldGroup.filter((item: { confRoom: { groupID: any; }; }) => item?.confRoom?.groupID !== conf?.confRoom?.groupID));
                            } else {
                              // janusRoomStatus(con?.confRoom?.groupID, true)
                            }
                          })
                        },
                        error: function (error: any) {
                          // janus.destroy();
                          try {
                            janus.destroy();
                          } catch (e) {

                          }
                        }
                      });

                    }
                  }
                }
              );
            },
            error: function (error: any) {
              //@ts-ignore
              window.Janus.error(error);
            },
            destroyed: function () {
            }
          });
      }
    });
  }

  useEffect(() => {
    fetchLiveRoomList();

    return () => {
      livesRoomAPI.abort();

      try {
        janus.destroy()
      } catch (e) {

      }
    };
  }, []);

  // @ts-ignore
  // @ts-ignore
  return (
    <Layout>
      <Content
        id="allGroupContainer"
        style={{
          width: "100%",
          minHeight: "calc(100vh - 50px)",
          overflow: "auto",
          alignSelf: "center",
        }}
        className={style.allGroupContainer}
      >
        <CenterConfirmModal
          cancelText={t("Cancel")}
          confirmText={t("Ok")}
          text={t("Do you want to live")}
          visible={showLiveModal}
          onCancel={() => {
            setShowLiveModal(false);
          }}
          onConfirm={onLive}
        />
        <Row
          style={{
            // fontSize: "20px",
            minHeight: "calc(100vh - 50px)",
            backgroundColor: "#F8F8F8",
            color: "#000000",
          }}
        >
          <div
            className={style.boxContent}
            style={{
              marginLeft: props.page === "chat" ? "252px" : "0px",
              width: props.page === "chat" ? "100%" : "100%",
            }}
          >
            <div className={style.contentContainer}>
              <div className={style.liveHeader}>
                {/*<div style={{ fontSize: "1rem", fontWeight: 600 , width: 110 }}>*/}
                {/*  {t("Lives")}*/}
                {/*</div>*/}
                <div className={style.searchContainer}>
                  <div
                    className={style.searchIcon}
                    style={{
                      backgroundImage: `url(${requestIcon.searchIcon})`,
                    }}
                  />
                  <input
                    type="text"
                    className={style.searchInput}
                    placeholder={t("Search")}
                  />
                </div>
                {/*<div style={{ paddingLeft: 29, width: "100%" }}>*/}
                {/*    <Input*/}
                {/*        size="large"*/}
                {/*        placeholder="Search"*/}
                {/*        // prefix={<SearchOutlined />}*/}
                {/*        // onChange={(event) => {*/}
                {/*        //     searchGroup(event);*/}
                {/*        // }}*/}
                {/*        style={{ height: 40 }}*/}
                {/*    />*/}
                {/*</div>*/}
                <div className={style.liveBtn}>
                  {/* <Button className={styles.createGroupButton}
                                            onClick={handleLive}
                                    >
                                        {t("Live")}
                                    </Button> */}
                  <CenterButton
                      small
                    style={{
                      marginLeft: "3rem"
                    }}
                    onClick={() => {
                      setShowLiveModal(true);
                    }}>
                    {t("Live")}
                  </CenterButton>
                </div>
              </div>
              <div style={{ paddingTop: 50 }}>
                {/*<InfiniteScroll*/}
                {/*    dataLength={liveRoomList == null ? 0 : liveRoomList?.length}*/}
                {/*    next={fetchNextGroup}*/}
                {/*    hasMore={hasMoreGroup}*/}
                {/*    scrollableTarget={"allGroupContainer"}*/}
                {/*    loader={*/}
                {/*        !hasMoreGroup ? null : (*/}
                {/*            <div className={styles.allCardGroup}>*/}
                {/*                <SkeletonCard />*/}
                {/*            </div>*/}
                {/*        )*/}
                {/*    }*/}
                {/*>*/}
                <CardContainer
                  header={t("Lives") + ` (${liveRoomList?.length || 0})`}
                // number={liveRoomList?.length}
                >
                  <div className={style.cardGroup}>
                    {!loaded ? (
                      <SkeletonCard />
                    ) : (
                      //@ts-ignore
                      liveRoomList?.map((live: any) => {
                        return (
                          <LiveCard
                            key={live?.friend?.id}
                            id={live?.friend?.id}
                            coverImgURL={live?.friend?.imageProfileURL}
                            name={live?.friend?.firstname}
                            confRoomId={live?.confRoom?.confRoomID}
                          />
                        );
                      })
                    )}
                  </div>
                </CardContainer>
                {(liveRoomList?.length === 0 && liveRoomList !== null) && (
                  <NoData header={noDataHeaderText} detail={nodatatext} />
                )}
                {/*</InfiniteScroll>*/}
              </div>
            </div>
          </div>
        </Row>
      </Content>
    </Layout>
  );
};

export default Lives;
